export default {
    home: {
        Entrar:'Entrar',
        Registro:'Registro',
        Recharge:'Recharge',
        Withdrawal:'Withdrawal',
        exitText:'This operation will log you out. Do you want to continue?',
        hint:'hint',
        Sure:'Sure',
        Cancel:'Cancel',
        exit_successfully:'exit successfully',
        winners:'winners',
        Account:'Account',
        Number:'Number',
        Amount_of_money:'Amount of money',
        Multiple:'Multiple',
        Total_amount:'Total amount',
        Confirm:'Confirm'
    },
    activity:{
        Recharge:'Recharge',
        Game:'Game',
        Member:'Member',
        Agent:'Agent'
    },
    deposit:{
        Category:'Category',
        Recharge_amount:'Recharge amount',
        Time:'Time',
        Recharge:'Recharge',
        Withdrawal_amount:'Withdrawal amount',
        Game:'Game',
        Betting_amount:'Betting amount',
        Recharge_records:'Recharge records',
        Withdrawal_records:'Withdrawal records',
        Betting_records:'Betting records',
        Withdrawal:'Withdrawal',
        Betting:'Betting'
    },
    invite:{
        Bonus_recebido:'Invitation bonus received',
        Numero_convite:'Total number of invitations',
        Meu_convite:'My invitation link',
        Receber:'Receiving',
        Membro:'Member',
        VIP:'VIP',
        Number_Invitations:'Number of Invitations',
        Recarga_total:'Recarga total',
        Apostas_totales:'Apostas totales',
        Receitas_geradas:'Revenue generated',
        Category:'Category',
        Recharge_amount:'Recharge amount',
        Time:'Time',
        Bonus:'Bonus',
        Regra:'Regra',
        Equipe:'Equipe',
        Commission:'Commission Record'
    },
    letter:{
        Receive:'Receive',
        Letter:'Letter',
        Anuncio:'Anuncio',
    },
    my:{
        Balance_account:'Balance account',
        Withdrawable_account:'Withdrawable account',
        Commission_account:'Commission account',
        Value_lock:'Value to lock',
        Current_level:'Current level',
        VIP_details:'VIP details',
        Game_Record:'Game Record'
    },
    setup:{
        Name:'Name:',
        Phone:'Phone:',
        Mail:'Mail:',
        Security_code:'Security code:',
        Save:'Save'
    },
    vip:{
        update_criteria:'update criteria',
        Total_deposit:'Total deposit',
        Apostas_totales:'Apostas totales',
        Level_privileges:'Member level description',
        Withdrawal_equity:'Withdrawal of equity',
        Announce_rewards:'Announce rewards',
        Deposit:'Deposit',
        Category:'Category',
        Bonus_amount:'Bonus amount',
        Time:'Time',
        VIP:'VIP',
        Bonus_VIP:'Bonus VIP',
        Introduction:'Introduction to the level',
        before:'before',
        after:'after',
    },
    login_register:{
        Login:'Login',
        Register:'Register',
        Confirm:'Confirm your account and password before logging in',
        Forgot_password:'Forgot password',
        Verification_code:'Verification code',
        tow_password:'two passwords are inconsistent'
    },
    Recharge:{
        Extractable_quantity:'Extractable quantity',
        Enter_your_withdrawal_amount:'Enter your withdrawal amount',
        Please_enter_your_amount:'Please enter your amount',
        Phone_number:'Phone number',
        Enter_phone_number:'Enter phone number',
        Pix_Enter_your_amount:'Pix Enter your amount',
        Chave_Pix:'Chave Pix (CPF)',
        Retirar:'Retirar',
    },
    Sidebar:{
        VIP_Bonus:'VIP Bonus',
        Play_History:'Play History',
        Download:'Download',
        Mail:'Mail',
        set_up:'Set up',
        Betting_record:'Betting record',
        Recharge:'Recharge',
        Withdraw:'Withdraw',
    },
    withdraw:{
        Deposit:'Deposit',
        Your_Balance:'Your Balance',
        Choose_deposit_method:'Choose a deposit method',
        PPDBET_Pix:'PPDBET-Pix'
    }
}
